angular.module('llax')
    .controller('BillingCallbackController', function() {});
